// Pure helpers for building social-share URLs. No React, no DOM — so they
// can be unit-tested under Node (Vitest) without jsdom. ESM (named exports)
// because consumers are JSX bundled by Rollup, which does static analysis.
//
// The four destinations match the marketing-plan Phase-3 brief: Copy link,
// WhatsApp, X/Twitter, Email. Telegram is kept alongside because the modal
// already exposed it and removing it would be a regression.

export const DEFAULT_SHARE_TEXT = (poolName) =>
  `Join my SWEEP:WC26 pool "${poolName}" — pick a team and ride it to the trophy.`;

export const DEFAULT_EMAIL_SUBJECT = (poolName) =>
  `Join my SWEEP:WC26 pool — ${poolName}`;

// Build the per-destination URLs from a pool URL + free-text share message.
// Email body keeps the URL on its own line so mail clients auto-linkify it.
export function buildShareTargets({ url, poolName }) {
  const text = DEFAULT_SHARE_TEXT(poolName);
  const subject = DEFAULT_EMAIL_SUBJECT(poolName);
  const fullText = `${text} ${url}`;
  const emailBody = `${text}\n\n${url}`;

  return {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(fullText)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    twitter:  `https://twitter.com/intent/tweet?text=${encodeURIComponent(fullText)}`,
    email:    `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`,
    text,
    fullText,
  };
}
